import React, { useState } from "react";
import { Button, Col, Form, Modal, Row } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import Select from "react-select";
import Fieldset from "../../../../Components/Common/Fieldset/Fieldset";
import {
  getAllProductVariant,
  getProductAttributes,
  readData,
} from "../OrderService";
import {
  setDoctorCategory,
  setProductVariantModalState,
  setSelectedAttributes,
} from "../../../../slices/orders/orderSlice";
import "../Order.scss";
import { useEffect } from "react";
import { formatAmount } from "../../../../Utils/CommonUtils";
import { useParams } from "react-router-dom";

function OemModal({ show, onHide, selectedProductEntityId, mode }) {
  const dispatch = useDispatch();
  const productAttributeData = useSelector(
    (state) => state.order.productAttributeData
  );
  const { id } = useParams();
  const productVariantModalState = useSelector(
    (state) => state.order.productVariantModalState
  );
  const productVariant = useSelector(
    (state) => state.order.selectedOrders.productVariant
  );

  const productAttributesList = productAttributeData?.flatMap(
    (product) => product.product_attributes_list || []
  );
  const [apiSuccess, setApiSuccess] = useState(false);

  const [selectedOem, setSelectedOem] = useState(null);
  const handleOemChange = (code, attributeMap, finalPremium, coverAmount) => {
    const selectedOption = {
      value: code,
      variant_json: attributeMap,
      finalPremium: finalPremium,
      coverAmount: coverAmount,
    };
    setSelectedOem(selectedOption);
    dispatch(
      setProductVariantModalState({
        ...productVariantModalState,
        oem: code,
        variant: selectedOption.variant_json,
        finalPremium: selectedOption.finalPremium,
        coverAmount: selectedOption.coverAmount,
      })
    );
  };

  const handleSave = () => {
    onHide();
    if (id) {
      dispatch(
        setProductVariantModalState({
          ...productVariantModalState,
          variant: null,
        })
      );
    }
  };

  useEffect(() => {
    if (id) {
      readData(id, "ODR");
    }
  }, [id]);

  // useEffect(() => {
  //   if (id) {
  //     handleGetCode();
  //   }
  // }, [id, productVariantModalState.oem, productVariantModalState.tenure]);

  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
      backdrop="static"
      keyboard={false}
      className="border-0"
      modalClassName="modal fade zoomIn"
      toggle={onHide}
      size="lg"
    >
      <Form className="tablelist-form">
        <Modal.Header className="p-3 bg-info-subtle" closeButton>
          Attributes
        </Modal.Header>
        <Modal.Body className="modal-body">
          {apiSuccess && (
            <Row>
              <div className="attributes-header">Insurance Company</div>
              {productVariant.content?.map((product, index) => {
                return (
                  <div className="d-flex gap-5" key={index}>
                    {product.product_variants.map((oem, oemIndex) => {
                      console.log("Checking pspOem:", oem.pspOem); // Debugging log

                      if (!oem.pspOem) {
                        return null; // Skip rendering if pspOem is missing
                      }

                      return (
                        <Form.Check
                          key={`oem-${index}-${oemIndex}`}
                          type="radio"
                          id={`oem-${index}`}
                          label={oem.pspOem.name}
                          value={oem.pspOem.name}
                          checked={
                            productVariantModalState &&
                            productVariantModalState.oem === oem.pspOem.code
                          }
                          onChange={() =>
                            handleOemChange(
                              oem.pspOem.code,
                              product.attribute_map,
                              product.final_premium,
                              product.attribute_map.cover
                            )
                          }
                        />
                      );
                    })}

                    <p>
                      Premium Amount -{" "}
                      {formatAmount(product.final_premium, null, null, "lakh")}
                    </p>
                  </div>
                );
              })}
            </Row>
          )}
        </Modal.Body>
        <Modal.Footer>
          {productVariantModalState.variant && (
            <Button type="button" onClick={handleSave} disabled={!selectedOem}>
              {id ? "Save" : "Save"}
            </Button>
          )}
        </Modal.Footer>
      </Form>
    </Modal>
  );
}

export default OemModal;
